exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.home-button[data-v-670811c0]{margin:0 .5rem .3rem .5rem;height:.88rem;border-radius:4px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;align-items:center;font-size:16px;background-image:-webkit-linear-gradient(0deg, #3b8dfb, #63a6ff);color:#fff\n}\n.flow-button[data-v-670811c0]{color:#007aff\n}", ""]);

// exports
